import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWind } from '@fortawesome/free-solid-svg-icons'
const Wind = ({speed, deg}) => {
    return(
        <div className="windWrapper">
            <FontAwesomeIcon icon={faWind}/>
            <h3 className="wind">{speed}m/h</h3>
            <h3 className="windDirection">{deg}°</h3>
        </div>
    )
}

export default Wind